// https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
// polyfill
// canvas.toDataURL may not work in iOS: http://stackoverflow.com/questions/26152652/ios-html5-canvas-todataurl
if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value(callback, type, quality) {
      const binStr = atob(this.toDataURL(type, quality).split(',')[1]);
      const len = binStr.length;
      const arr = new Uint8Array(len);
      if (binStr.length === 0) {
        throw 'Unable to generate Data URL';
      }

      if (binStr.length === 0) {
        throw 'Unable to generate Data URL';
      }

      if (binStr.length === 0) {
        throw 'Unable to generate Data URL';
      }

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      callback(new Blob([arr], { type: type || 'image/png' }));
    },
  });
}

const ORIENTATION = {
  LANDSCAPE: 1,
  PORTRAIT: 2,
};

const calculateOrientation = function (image) {
  return image.width >= image.height ? ORIENTATION.LANDSCAPE : ORIENTATION.PORTRAIT;
};

// from https://gist.github.com/mfyz/10198229#file-resize_preview-html-L100
export const localFileResize = function (file, size, callback) {
  const reader = new FileReader();

  reader.onload = onReaderLoaded;
  reader.readAsDataURL(file);

  function onReaderLoaded() {
    const image = new Image();
    image.onload = onImageLoaded;
    image.src = this.result;
  }

  function onImageLoaded() {
    const orientation = calculateOrientation(this);

    // shrink longest edge to size
    if (orientation === ORIENTATION.PORTRAIT && this.height > size) {
      this.width *= size / this.height;
      this.height = size;
    }

    if (orientation === ORIENTATION.LANDSCAPE && this.width > size) {
      this.height *= size / this.width;
      this.width = size;
    }

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvas.width = this.width;
    canvas.height = this.height;
    ctx.drawImage(this, 0, 0, this.width, this.height);
    try {
      canvas.toBlob(callback, 'image/jpeg');
    } catch (error) {
      console.warn(error); // Optional
      return callback(file);
    }
  }
};

// Disable client side file resize for touch screen devices until further notice
export const ABLE_TO_RESIZE = false; // screenAndStyle.isTouch();
